<div class="notes-container">
  <!-- Header sekcji -->
  <div class="section-header">
    <h2 class="section-title">Notatki i wpisy</h2>
    <button mat-raised-button routerLink='add' class="add-button">
      <mat-icon>add</mat-icon> Dodaj notatke
    </button>
  </div>

  <!-- Pasek wyszukiwania -->
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Szukaj notatek...</mat-label>
      <input matInput [formControl]="filter" (blur)="saveFilter()">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <!-- Tabs z notatkami -->
  <mat-tab-group class="notes-tabs" [(selectedIndex)]="selectedNoteIndex" (selectedTabChange)="onTabChange($event)">
    <!-- Tab: Wpisy -->
    <mat-tab label="📝 Wpisy ({{ serviceEntry.length }})">
      <div class="tab-content">
        <div class="notes-grid" *ngIf="serviceEntry.length > 0; else emptyServiceEntry">
          <mat-card *ngFor="let note of serviceEntry" class="note-card-item">
            <mat-card-header class="card-header">
              <mat-card-title class="note-title">{{ note.title }}</mat-card-title>
              <div class="card-actions">
                <button mat-icon-button class="d-flex justify-content-center" [routerLink]="'show/'+note.id" matTooltip="Wyświetl">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button class="d-flex justify-content-center" matTooltip="Edytuj" (click)="onEdit(note.id!)" *ngIf="user.is_admin && user.is_admin > 0">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" class="d-flex justify-content-center" (click)="onDeleteNote(note.id!)" matTooltip="Usuń"  *ngIf="user.is_admin && user.is_admin > 0">
                  <mat-icon>delete</mat-icon>
                </button>
                <button mat-icon-button color="warn" class="d-flex justify-content-center" (click)="onRequestDelete(note.id!)" matTooltip="Usuń"  *ngIf="note.creator.id === user.id && user.is_admin === 0">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-card-header>
            <mat-card-content>
              <p class="note-preview">{{ note.note | slice:0:100 }}{{ note.note.length > 100 ? '...' : '' }}</p>
            </mat-card-content>
            <mat-card-footer class="card-footer">
              <span class="note-type">{{ note.note_type }}</span>
              <span class="note-date">{{ note.created_at | date:'short' }}</span>
            </mat-card-footer>
          </mat-card>
        </div>
        <ng-template #emptyServiceEntry>
          <div class="empty-state">
            <mat-icon class="empty-icon">description</mat-icon>
            <p>Brak wpisów serwisowych</p>
          </div>
        </ng-template>
      </div>
    </mat-tab>

    <!-- Tab: Notatki -->
    <mat-tab label="📌 Notatki ({{ notes.length }})">
      <div class="tab-content">
        <div class="notes-grid" *ngIf="notes.length > 0; else emptyNotes">
          <mat-card *ngFor="let note of notes" class="note-card-item">
            <mat-card-header class="card-header">
              <mat-card-title class="note-title">{{ note.title }}</mat-card-title>
              <div class="card-actions">
                <button mat-icon-button class="d-flex justify-content-center" [routerLink]="'show/'+note.id" matTooltip="Wyświetl">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button class="d-flex justify-content-center" matTooltip="Edytuj" (click)="onEdit(note.id!)"  *ngIf="note.creator.id === user.id || user.is_admin && user.is_admin > 0">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" class="d-flex justify-content-center" (click)="onDeleteNote(note.id!)" matTooltip="Usuń"  *ngIf="note.creator.id === user.id || user.is_admin && user.is_admin > 0">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-card-header>
            <mat-card-content>
              <p class="note-preview">{{ note.note | slice:0:100 }}{{ note.note.length > 100 ? '...' : '' }}</p>
            </mat-card-content>
            <mat-card-footer class="card-footer">
              <span class="note-type">{{ note.note_type }}</span>
              <span class="note-date">{{ note.created_at | date:'short' }}</span>
            </mat-card-footer>
          </mat-card>
        </div>
        <ng-template #emptyNotes>
          <div class="empty-state">
            <mat-icon class="empty-icon">note</mat-icon>
            <p>Brak notatek</p>
          </div>
        </ng-template>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>